import TablePageTitle from './TablePageTitle';

export default TablePageTitle;
